import { useParams } from 'react-router-dom';
import { Message } from 'rsuite';
import usePermissions from '../hooks/usePermissions';

// Renders a page only when allowed(permissions, routeParams) says so.
export default function RequireAccess({ allowed, children }) {
  const permissions = usePermissions();
  const params = useParams();

  if (!permissions.loaded) return null;
  if (allowed(permissions, params)) return children;
  return (
    <Message type="warning" showIcon>
      You don&rsquo;t have permission to view this page.
    </Message>
  );
}
